//expenses link to summary card and quick action button

import React, { useState, useEffect } from "react";
import api from "../../../Api/api";

function SplitBillModal({ onClose, onAddExpense }) {
  const [amount, setAmount] = useState(0);
  const [description, setDescription] = useState('');
  const [groupId, setGroupId] = useState('');
  const [groupList, setGroupList] = useState([]);

  // Get current user info
  const currentUser = JSON.parse(localStorage.getItem("currentUser"));
  console.log("Current user:", currentUser);

  // Load user's groups for dropdown
  useEffect(() => {
    api.get('/dashboard/groups')
    .then(response => {
      const data = Array.isArray(response.data.groups) ? response.data.groups : [];
      console.log("Fetched group list:", data);
      setGroupList([...data]);
    })
    .catch(error => {
      console.error('Error fetching groups:', error);
      setGroupList([]); // fallback to safe default
    });
}, []);

  // handle the submit
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!currentUser) {
      alert("Only logged-in users can split bills.");
      return;
    }

    try {
     
      // 2. Create the new split object
      const newSplit = {
        description,
        totalAmount: parseFloat(amount),
        groupId: parseInt(groupId),
        date: new Date().toISOString()
      };

      // 3. Save to /splits
      const response = await api.post('/expense/create', newSplit);

      // Notify dashboard (SummaryCards) 
      if (onAddExpense) {
        onAddExpense(response.data);
      }

      // Clear and close
      setAmount('');
      setDescription('');
      setGroupId('');
      onClose();

    } catch (error) {
      console.error("Error splitting bill:", error);
      alert("Failed to create expense.");
    }
  };


  return (
    <form onSubmit={handleSubmit}>
      <div className="mb-3">
        <label className="form-label">Amount</label>
        <input
          type="number"
          className="form-control"
          value={isNaN(amount) ? "" : amount}
          onChange={e => setAmount(e.target.value)}
          required
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Description</label>
        <input
          type="text"
          className="form-control"
          value={description}
          onChange={e => setDescription(e.target.value)}
          required
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Group</label>
        <select
          className="form-control"
          value={parseInt(groupId)}
          onChange={e => setGroupId(parseInt(e.target.value))}
          required
        >
          <option value="">Select a  group</option>
          {groupList.map(group => (
            <option key={group.id} value={group.id.toString()}>{group.name}</option>
          ))}
        </select>
      </div>
      <button type="submit" className="btn btn-primary">Create Expense</button>
    </form>
  );
}

export default SplitBillModal;